import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    CustomCollapseCard,
    CustomButton,
    CustomImage,
    CustomPagination,
    successDialog,
    Text,
    useText,
} from '@src/components';

import { orderDelete, orderGetPageList, setSelectedOrder } from '@src/store/slice/orderSlice';
import { getOrderLimitDate, resetOrderLimits } from '@src/store/slice/orderLimitsSlice';
import { getCustomerVouList } from '@src/store/slice/customerSlice';

import reportsServices from '@src/services/reports.services';

import dayjs from '@src/utils/day';
import { defaultDateFormat } from '@src/utils/keys';
import { handleAuthStatus, moneyFormat, previewDownload } from '@src/utils/utils';

import { Collapse } from 'antd';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import iconDetail from '@src/assets/icons/detail-img.svg';
import iconNpInfo from '@src/assets/icons/icon-info.svg';
import iconDowndload from '@src/assets/icons/download-img.svg';
import iconPrinter from '@src/assets/icons/printer-img.svg';
import iconGiftDown from '@src/assets/icons/gift-icn-down.svg';
import iconGiftUp from '@src/assets/icons/gift-icn-up.svg';
import '@src/styles/myOrders/orderList.scss';
import DownloadModal from '@src/pages/ticketRestaurant/myOrders/DownloadModal';
import PaymentModal from '@src/pages/ticketRestaurant/myOrders/PaymentModal';
import OrderSummaryCardModal from '@src/pages/ticketRestaurant/myOrders/OrderSummaryCardModal';
import OrderSummaryBalanceModal from '@src/pages/ticketRestaurant/myOrders/OrderSummaryBalanceModal';
import OrderFilter from '@src/pages/ticketRestaurant/myOrders/OrderFilter';
import CustomPopover from '@src/components/CustomPopover';
import PropTypes from 'prop-types';
import { warningDialog } from '@src/components/CustomDialog';
import propTypes from 'prop-types';
import { FilterOrderTypeValue } from '@src/store/enums';

const { Panel } = Collapse;

function getExpandIcon(setActiveCollapse, switchIcon, setActiveOrder, orderId, activeOrderId) {
    const ExpandIcon = ({ isActive }) => {
        setActiveCollapse(isActive);
        if (isActive) {
            setActiveOrder(orderId);
        } else if (activeOrderId && orderId === activeOrderId) {
            setActiveOrder(null);
        }
        return (
            <div style={{ borderRadius: '24px' }}>
                {isActive ? (
                    <CustomImage className="open-close" src={!switchIcon ? iconGiftUp : iconGiftDown} />
                ) : (
                    <CustomImage className="open-close" src={!switchIcon ? iconGiftDown : iconGiftUp} />
                )}
            </div>
        );
    };
    ExpandIcon.propTypes = {
        isActive: PropTypes.bool,
    };
    return ExpandIcon;
}
getExpandIcon.propTypes = {
    setActiveCollapse: PropTypes.func,
    switchIcon: PropTypes.any,
    setActiveOrder: PropTypes.func,
    orderId: PropTypes.any,
    activeOrderId: PropTypes.any,
};

function OrderPanelHeader({ order, isMobil, orderBalanceText, orderStyles }) {
    return (
        <div style={{ textAlign: 'left', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: isMobil ? '100% !important' : 'auto !important' }}>
            <div>
                <p>
                    <Text t="orderNo" />
                </p>
                <span>{order?.id}</span>
            </div>
            {!isMobil ? (
                <div>
                    <p>
                        <Text t="orderType" />
                    </p>
                    <span>{orderBalanceText}</span>
                </div>
            ) : null}
            {!isMobil ? (
                <div>
                    <p>
                        <Text t="orderAmount2" />
                    </p>
                    <span>{moneyFormat(order?.totalPrice, false)} TL</span>
                </div>
            ) : null}
            {!isMobil ? (
                <div>
                    <p>
                        <Text t="orderDate2" />
                    </p>
                    <span>{dayjs(order?.orderDate).format(defaultDateFormat)}</span>
                </div>
            ) : null}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', marginRight: 30 }}>
                <div className="order-status-name-badge" style={{ backgroundColor: orderStyles.backgroundColor }}>
                    <p style={{ color: orderStyles.color, fontFamily: 'UbuntuRegular' }}>{order?.orderStatusName}</p>
                </div>
            </div>
        </div>
    );
}
OrderPanelHeader.propTypes = {
    order: PropTypes.object,
    isMobil: PropTypes.bool,
    orderBalanceText: PropTypes.string,
    orderStyles: PropTypes.object,
};

function OrderSummaryFirstColumn({ order, isMobil }) {
    const rowSpacingStyle = { marginTop: isMobil ? '0.5rem' : 0, marginBottom: isMobil ? '0.5rem' : 0 };
    const labelStyle = { fontSize: isMobil ? '12px' : '14px', marginBottom: 0, paddingTop: isMobil ? 0 : '12px', paddingBottom: isMobil ? '6px' : '12px', color: '#475569' };
    const valueStyle = { fontSize: isMobil ? '12px' : '14px', marginBottom: '0px !important', color: '#1e293b' };

    return (
        <div className="gift-order-list-detail-card-summary-first-area" style={{ paddingLeft: isMobil ? '0px' : '1rem', minWidth: isMobil ? '100%' : '31%' }}>
            <div style={rowSpacingStyle}>
                <p style={labelStyle}>
                    <Text t="orderCreatedBy" />
                </p>
                <span style={valueStyle}>{order?.createdUser}</span>
            </div>
            <div style={rowSpacingStyle}>
                <p style={{ ...labelStyle, width: isMobil ? '38%' : 'auto', lineHeight: isMobil ? '16px' : 'inherit' }}>
                    <Text t="dateWhenBalanceWillBeAvailable2" />
                </p>
                <span style={valueStyle}>{dayjs(order?.activationDate).format(defaultDateFormat).replaceAll('.', '/')}</span>
            </div>
        </div>
    );
}
OrderSummaryFirstColumn.propTypes = {
    order: PropTypes.object,
    isMobil: PropTypes.bool,
};

function OrderSummarySecondColumn({ order, isMobil, paymentMethodKey }) {
    const rowSpacingStyle = { marginTop: isMobil ? '0.5rem' : 0, marginBottom: isMobil ? '0.5rem' : 0 };
    const labelStyle = { fontSize: isMobil ? '12px' : '14px', marginBottom: 0, paddingTop: isMobil ? 0 : '12px', paddingBottom: isMobil ? '6px' : '12px' };
    const valueStyle = { fontSize: isMobil ? '12px' : '14px', marginBottom: '0px !important' };

    return (
        <div className="gift-order-list-detail-card-summary-second-area" style={{ paddingRight: isMobil ? '0px' : '1rem', minWidth: isMobil ? '100%' : '31%' }}>
            {order.orderTypeId !== 11 && (
                <div style={{ marginBottom: isMobil ? '0.5rem' : 0 }}>
                    <p style={labelStyle}>
                        <Text t="amountToBePaid" />{' '}
                    </p>
                    <span style={valueStyle}>{order?.paymentTotalPrice} TL</span>
                </div>
            )}

            <div style={rowSpacingStyle}>
                <p style={labelStyle}>
                    <Text t="paymentMethod" />{' '}
                </p>
                <span style={valueStyle}><Text t={paymentMethodKey} /></span>
            </div>
        </div>
    );
}
OrderSummarySecondColumn.propTypes = {
    order: PropTypes.object,
    isMobil: PropTypes.bool,
    paymentMethodKey: PropTypes.string,
};

function OrderSummaryThirdColumn({ order, isMobil, orderLimitDate }) {
    const rowSpacingStyle = { marginTop: isMobil ? '0.5rem' : 0, marginBottom: isMobil ? '0.5rem' : 0 };
    const labelStyle = { fontSize: isMobil ? '12px' : '14px', marginBottom: 0, paddingTop: isMobil ? 0 : '12px', paddingBottom: isMobil ? '6px' : '12px' };
    const valueStyle = { fontSize: isMobil ? '12px' : '14px', marginBottom: '0px !important' };
    const lastPaymentDateValue = orderLimitDate?.data?.limitDate !== null
        ? dayjs(orderLimitDate?.data?.limitDate).format(defaultDateFormat)
        : '-';

    return (
        <div className="gift-order-list-detail-card-summary-second-area" style={{ paddingRight: isMobil ? '0px' : '1rem', minWidth: isMobil ? '100%' : '31%' }}>
            <div style={rowSpacingStyle}>
                <p style={labelStyle}>
                    <Text t="numberOfCards2" />{' '}
                </p>
                <span style={valueStyle}>{order?.totalCount}</span>
            </div>
            <div style={{ ...rowSpacingStyle, borderBottom: '1px solid #cbd5e1' }}>
                <p style={labelStyle}>
                    <Text t="lastPaymentDate" />
                </p>
                <span style={valueStyle}>{lastPaymentDateValue}</span>
            </div>
        </div>
    );
}
OrderSummaryThirdColumn.propTypes = {
    order: PropTypes.object,
    isMobil: PropTypes.bool,
    orderLimitDate: PropTypes.object,
};

function OrderSummarySection({ order, isMobil, orderLimitDate, paymentMethodKey }) {
    return (
        <div className="gift-order-list-detail-card-summary" style={{ flexDirection: isMobil ? 'column' : 'row' }}>
            <OrderSummaryFirstColumn order={order} isMobil={isMobil} />
            <OrderSummarySecondColumn order={order} isMobil={isMobil} paymentMethodKey={paymentMethodKey} />
            <OrderSummaryThirdColumn order={order} isMobil={isMobil} orderLimitDate={orderLimitDate} />
        </div>
    );
}
OrderSummarySection.propTypes = {
    order: PropTypes.object,
    isMobil: PropTypes.bool,
    orderLimitDate: PropTypes.object,
    paymentMethodKey: PropTypes.string,
};

function OrderActionsFooter({ order, isMobil, userAuthorizationStatus, onCancel, showButtonNode }) {
    return (
        <div className="gift-order-list-detail-card-footer" style={{ flexDirection: isMobil ? 'column' : 'row', justifyContent: 'center', marginBottom: 10, marginTop: 20 }}>
            {!handleAuthStatus(userAuthorizationStatus, 'MyOrdersCancel') && (
                <>
                    {order?.orderCancel === false && order?.showCancelButton === true && (
                        <CustomButton id="ticketRestaurant-myOrders-orderList-gift-order-list-detail-card-footer-cancel" data-testid="delete" onClick={() => { return onCancel(order); }} className="gift-order-list-detail-card-footer-cancel" style={{ margin: isMobil ? '0px' : '0 0 0 40px', color: '#eb1000', textDecoration: 'underline' }}>
                            <Text t="cancelOrder" />
                        </CustomButton>
                    )}
                </>
            )}

            {showButtonNode}
        </div>
    );
}
OrderActionsFooter.propTypes = {
    order: PropTypes.object,
    isMobil: PropTypes.bool,
    userAuthorizationStatus: PropTypes.object,
    onCancel: PropTypes.func,
    showButtonNode: PropTypes.node,
};

function OrderExpandLinks({ order, isMobil, userAuthorizationStatus, onDetail, onDownload, onPrint }) {
    return (
        <div className="gift-order-list-detail-card-link" style={{ flexDirection: isMobil ? 'column' : 'row', justifyContent: 'center', alignItems: 'center', marginTop: isMobil ? '2.5rem' : '0px', marginBottom: isMobil ? '3.5rem' : '0px', gap: '20px' }}>
            {!handleAuthStatus(userAuthorizationStatus, 'MyOrdersList') && (
                <button type="button" style={{ backgroundColor: 'transparent', borderWidth: 0 }}>
                    <button type="button" className="order-expand-buttons" onClick={() => onDetail(order)}>
                        <CustomImage className="order-expand-button-img" src={iconDetail} />
                        <span className="order-expand-button-text"><Text t="seeDetail" /></span>
                    </button>
                </button>
            )}
            {!handleAuthStatus(userAuthorizationStatus, 'MyOrdersDownload') && (
                <button type="button" style={{ backgroundColor: 'transparent', borderWidth: 0 }}>
                    <button type="button" className="order-expand-buttons" onClick={() => onDownload(order)}>
                        <CustomImage className="order-expand-button-img" src={iconDowndload} />
                        <span className="order-expand-button-text"><Text t="download2" /></span>
                    </button>
                </button>
            )}
            {!handleAuthStatus(userAuthorizationStatus, 'MyOrdersDownload') && (
                <button type="button" style={{ backgroundColor: 'transparent', borderWidth: 0 }}>
                    <button type="button" className="order-expand-buttons" onClick={() => onPrint(order)}>
                        <CustomImage className="order-expand-button-img" src={iconPrinter} />
                        <span className="order-expand-button-text"><Text t="print2" /></span>
                    </button>
                </button>
            )}
        </div>
    );
}
OrderExpandLinks.propTypes = {
    order: PropTypes.object,
    isMobil: PropTypes.bool,
    userAuthorizationStatus: PropTypes.object,
    onDetail: PropTypes.func,
    onDownload: PropTypes.func,
    onPrint: PropTypes.func,
};

const SharedOrderList = ({ vouId, isMarket, isCompliments, userAuthorizationStatus }) => {
    const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });

    const dispatch = useDispatch();

    const { list, tableProperty, filterObject } = useSelector((state) => state?.order);
    const { orderLimitDate } = useSelector((state) => state?.orderLimits);
    const { selectedCustomer } = useSelector((state) => state?.customer);
    const { customerVou } = useSelector((state) => state?.customer);

    const [activeCollapse, setActiveCollapse] = useState(false);
    const [activeOrder, setActiveOrder] = useState(null);
    const [downloadModalVisible, setDownloadModalVisible] = useState(false);
    const [paymentModalVisible, setPaymentModalVisible] = useState(false);
    const [orderSummaryCardModalVisible, setOrderSummaryCardModalVisible] = useState(false);
    const [orderSummaryBalanceModalVisible, setOrderSummaryBalanceModalVisible] = useState(false);

    const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');
    const handleTableChange = useCallback(
        async (pageNumber, pageSize) => {
            await dispatch(orderGetPageList({ ...filterObject, vouId, pageNumber, pageSize }));
            await dispatch(resetOrderLimits());
        },
        [dispatch, filterObject, vouId],
    );

    useEffect(() => {
        dispatch(getCustomerVouList({ customerId: selectedCustomer?.customerId, vouId }));
    }, [dispatch, selectedCustomer?.customerId, vouId]);

    const handleDetail = (record) => {
        dispatch(setSelectedOrder(record));
        record.orderTypeId === 9
            ? setOrderSummaryCardModalVisible(true)
            : setOrderSummaryBalanceModalVisible(true);
    };

    const handlePrint = async (record) => {
        const data = {
            customerId: selectedCustomer?.customerId,
            orderId: record?.id,
            vouId,
        };

        try {
            const blob = await reportsServices.getOrderReport(data);
            await previewDownload(blob);
        } catch (error) {
            console.error(error);
        }
    };

    const handleDownloadModal = (record) => {
        dispatch(setSelectedOrder(record));
        setDownloadModalVisible(true);
    };

    const handlePaymentLink = async (record) => {
        dispatch(setSelectedOrder(record));
        setPaymentModalVisible(true);
    };

    const cancelOrder = async (body) => {
        const action = await dispatch(orderDelete(body));
        if (orderDelete.fulfilled.match(action)) {
            successDialog({
                title: <Text t="success" />,
                message: action?.payload?.message || yourTransactionHasBeenSuccessfullyCompleted,
                onOk: async () => {
                    await dispatch(orderGetPageList({ ...filterObject, vouId }));
                },
            });
        }
    };
    const handleCancel = async (record) => {
        const body = {
            id: record?.id,
            orderTypeId: record?.orderTypeId,
            vouId,
        };

        warningDialog({
            title: <Text t="attention" />,
            htmlContent: (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <span className="gift-cancel-order-head">
                        <Text t="youAreAboutToCancelYourOrder" />
                    </span>
                    <p className="gift-cancel-order-text">
                        <Text t="whenYouApproveThisTransactionYourOrderWill" />
                    </p>{' '}
                    <p className="gift-cancel-order-text">
                        <Text t="areYouSureYouWantToPerformThe" />
                    </p>
                    <button
                        className="utts-ok-button gift-cancel-order-confirm"
                        onClick={() => cancelOrder(body)}
                    >
                        <Text t="cancel3" />
                    </button>
                    <button className="utts-cancel-button gift-cancel-order-cancel" onClick={() => null}>
                        <Text t="giveUp" />
                    </button>
                </div>
            ),
            className: 'warningModal-utts not-show-warning-buttons',
            okButtonProps: 'not-show-warning-buttons',
            onOk: async () => { },
            onCancel: async () => { },
        });
    };

    const isShowButton = (item) => {
        if (
            item?.paymentTotalPrice !== 0 &&
            item?.orderCancel === false &&
            item?.paymentResult === false &&
            customerVou.patId === 2 &&
            customerVou.pamId === 4 &&
            item?.isLinkPaymentOk === false
        ) {
            return (
                <>
                    {!item?.isLinkPaymentOk ? (
                        <CustomButton
                            id="ticketRestaurant-myOrders-orderList-gift-order-list-detail-card-footer-payment"
                            data-testid="pay"
                            onClick={() => {
                                return handlePaymentLink(item);
                            }}
                            className="gift-order-list-detail-card-footer-payment"
                            style={{
                                margin: isMobil ? '0px' : '0 0 0 20px',
                                backgroundColor: '#f66301',
                                borderRadius: 8,
                            }}
                        >
                            <Text t="pay2" />
                        </CustomButton>
                    ) : null}
                </>
            );
        }
    };

    const isPaymentMethod = () => {
        if (
            (customerVou.patId === 2 && customerVou.pamId === 5) ||
            (customerVou.patId === 2 && customerVou.pamId === 2)
        ) {
            return 'paymentType.transfer';
        } else if (
            (customerVou.patId === 1 && customerVou.pamId === 1) ||
            (customerVou.patId === 1 && customerVou.pamId === 5)
        ) {
            return 'paymentType.deferred';
        } else if (customerVou.patId === 2 && customerVou.pamId === 4) {
            return 'paymentType.creditCard';
        }
    };

    const handleChangeCollapse = (order) => {
        if (order?.id) {
            const data = {
                orderTypeId: order?.orderTypeId === FilterOrderTypeValue.balanceLoad ? 1 : 0,
                tempOrderNo: order?.id,
                vouId,
            };
            dispatch(getOrderLimitDate(data));
        }
    };

    const getOrderBalanceText = (order) => {
        return order?.orderTypeId === FilterOrderTypeValue.balanceLoad
            ? order?.orderTypeName
            : `${order?.orderTypeName} - ${order?.cardTypeName}`;
    };

    const getOrderStyles = (order) => {
        let res = {
            backgroundColor: 'transparent',
            color: '#f14c08',
            text: '',
        };
        if (order?.orderStatusName === 'Kargoda') {
            res.backgroundColor = '#f0efff';
            res.color = '#3000d4';
            res.text = 'Siparişiniz üretildi ve kargo firmasına teslim edildi.';
        } else if (order?.orderStatusName === 'Üretim Aşamasında') {
            res.backgroundColor = '#e5f0fe';
            res.color = '#006cfa';
            res.text =
                'Siparişiniz alındı ve üretim planına dahil edildi. Üretim aşaması için hazırlık yapılıyor.';
        } else if (
            order?.orderStatusName === 'Krediler Üretildi' ||
            order?.orderStatusName === 'Teslim Edildi'
        ) {
            res.backgroundColor = '#d1fadf';
            res.color = '#027a48';
            res.text =
                'Sipariş süreci başarıyla tamamlandı. Ürünler teslim edildi ve işlem sonlandırıldı.';
        } else if (order?.orderStatusName === 'Henüz Üretilmedi') {
            res.backgroundColor = '#ffeeed';
            res.color = '#bd0d00';
            res.text = 'Siparişiniz iptal edilmiştir.';
        }
        return res;
    };

    return (
        <CustomCollapseCard switchIcon={true} className="order-list-card" cardTitle={<Text t="myOrders" />} diffPage={false}>
            <OrderFilter {...(isMarket ? { isMarket: true } : {})} {...(isCompliments ? { isCompliments: true } : {})} />
            {list?.map((order) => {
                const isOrderBalance = getOrderBalanceText(order);
                const resOrderStyles = getOrderStyles(order);
                const showOrderActions = order?.orderStatusName !== 'Talep Alındı';
                return (
                    <Collapse
                        className={`order-list-card-new ${activeOrder === order.id ? 'gift-expand-active' : ''}`}
                        ghost
                        expandIconPosition="right"
                        expandIcon={getExpandIcon(setActiveCollapse, false, setActiveOrder, order.id, activeOrder)}
                        key={order.id}
                        switchIcon={false}
                        cardTitle={<Text t="orderTracking" />}
                        onChange={() => handleChangeCollapse(order)}
                    >
                        <Panel
                            header={
                                <OrderPanelHeader
                                    order={order}
                                    isMobil={isMobil}
                                    orderBalanceText={isOrderBalance}
                                    orderStyles={resOrderStyles}
                                />
                            }
                            key="1"
                        >
                            <div className="">
                                <div className="gift-order-list-detail-card" style={{ paddingLeft: isMobil ? '0.5rem' : '1.5rem', paddingRight: isMobil ? '0.5rem' : '2rem' }}>
                                    <div className="gift-order-list-detail-card-title"><h2><Text t="orderSummary2" /></h2></div>

                                    <OrderSummarySection
                                        order={order}
                                        isMobil={isMobil}
                                        orderLimitDate={orderLimitDate}
                                        paymentMethodKey={isPaymentMethod()}
                                    />
                                    {showOrderActions && (
                                        <OrderActionsFooter
                                            order={order}
                                            isMobil={isMobil}
                                            userAuthorizationStatus={userAuthorizationStatus}
                                            onCancel={handleCancel}
                                            showButtonNode={isShowButton(order)}
                                        />
                                    )}
                                    {showOrderActions && (
                                        <OrderExpandLinks
                                            order={order}
                                            isMobil={isMobil}
                                            userAuthorizationStatus={userAuthorizationStatus}
                                            onDetail={handleDetail}
                                            onDownload={handleDownloadModal}
                                            onPrint={handlePrint}
                                        />
                                    )}
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                );
            })}
            <div className="order-list-footer">
                <CustomPagination
                    current={tableProperty?.currentPage}
                    defaultCurrent={1}
                    pageSize={tableProperty?.pageSize}
                    total={tableProperty?.totalCount}
                    onChange={async (pageNumber, pageSize) => {
                        await handleTableChange(pageNumber, pageSize);
                    }}
                />
            </div>
            <DownloadModal modalVisible={downloadModalVisible} handleModalVisible={setDownloadModalVisible} {...(isMarket ? { isMarket: true } : {})} {...(isCompliments ? { isCompliments: true } : {})} />
            <PaymentModal modalVisible={paymentModalVisible} handleModalVisible={setPaymentModalVisible} {...(isMarket ? { isMarket: true } : {})} {...(isCompliments ? { isCompliments: true } : {})} paymentPage={handleAuthStatus(userAuthorizationStatus, 'PaymentAuthorizationGroup')} />
            <OrderSummaryCardModal modalVisible={orderSummaryCardModalVisible} handleModalVisible={setOrderSummaryCardModalVisible} {...(isMarket ? { isMarket: true } : {})} {...(isCompliments ? { isCompliments: true } : {})} />
            <OrderSummaryBalanceModal modalVisible={orderSummaryBalanceModalVisible} handleModalVisible={setOrderSummaryBalanceModalVisible} {...(isMarket ? { isMarket: true } : {})} {...(isCompliments ? { isCompliments: true } : {})} />
        </CustomCollapseCard>
    );
};

SharedOrderList.propTypes = {
    vouId: propTypes.string.isRequired,
    isMarket: propTypes.bool,
    isCompliments: propTypes.bool,
    userAuthorizationStatus: propTypes.object,
};

export default SharedOrderList;
